export default __webpack_public_path__ + "static/media/revisions.3a6771bd.svg";